module.exports = __webpack_public_path__ + "static/media/pontoIconSelect.903262c5.svg";